import styled from 'styled-components';
import type { TermsTone } from './index';

export const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Badge = styled.span<{ $tone: TermsTone }>`
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  white-space: nowrap;
  color: ${({ theme, $tone }) =>
    $tone === 'ok'
      ? theme.colors.success.success
      : $tone === 'pending'
        ? theme.colors.surface.onSurfaceVariant
        : theme.colors.danger.danger};
  border: 1px solid currentColor;
`;

export const ResendLink = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary.primary};

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;
